import { render } from "./Header.vue?vue&type=template&id=2ca568cf&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=2ca568cf&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2ca568cf"

export default script